import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-fetch-data',
  templateUrl: './fetch-data.component.html'
})
export class FetchDataComponent {
  public forecasts: WeatherForecast[];
  public Category: WeatherForecast[];

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    http.get<WeatherForecast[]>(baseUrl + 'api/SampleData/DisplayCategories').subscribe(result => {
      this.forecasts = result;
    }, error => console.error(error));
    http.get<WeatherForecast[]>(baseUrl + 'api/SampleData/DisplaySubCategories').subscribe(result => {
      this.Category = result;
    }, error => console.error(error));
  }
}

interface WeatherForecast {
  categoryID: number;
  categoryName: string;
  isParent: boolean;
  parentCategoryID: number;
  ProductCounter: number;
  childCategoryID: string;
  childCategoryName: string;
}



// WEBPACK FOOTER //
// ./src/app/fetch-data/fetch-data.component.ts